import { format } from "date-fns";

export const API = "/api";

// ─── localStorage keys ───
export const COL_WIDTHS_KEY = "crm_column_widths";
export const VISIBLE_COLS_KEY = "crm_visible_columns";
export const DETAIL_COLLAPSED_KEY = "crm_detail_collapsed";
export const DETAIL_COL_ORDER_KEY = "crm_detail_col_order";
export const DETAIL_MINIMIZED_KEY = "crm_detail_minimized";
export const LAST_CONTACT_KEY = "crm_last_contact_id";
export const SPLIT_HEIGHT_KEY = "crm_split_height";

// ─── Time helpers ───
export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const now = new Date();
  const mins = Math.floor((now - d) / 60000);
  if (mins < 1) return "gerade eben";
  if (mins < 60) return `vor ${mins} Min.`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `vor ${hrs} Std.`;
  const days = Math.floor(hrs / 24);
  if (days === 1) return "gestern";
  if (days < 30) return `vor ${days} Tagen`;
  try { return format(d, "dd.MM.yyyy"); } catch { return ""; }
}

export function fmtDate(d) {
  if (!d) return "";
  try { return format(new Date(d), "dd.MM.yyyy HH:mm"); } catch { return d; }
}

export function fmtDateShort(d) {
  if (!d) return "";
  try { return format(new Date(d), "dd.MM.yyyy"); } catch { return d; }
}

export function getLetzteAktivitaet(la) {
  if (!la) return { text: "", zeit: "" };
  if (typeof la === "string") return { text: "", zeit: timeAgo(la) };
  return {
    text: la.aktion || "",
    benutzer: la.benutzer || "",
    zeit: timeAgo(la.zeit),
  };
}

// ─── Column definitions ───
export const ALL_COLUMNS = [
  { key: "kundennummer", label: "KD Nr.", removable: true },
  { key: "firma", label: "Firmenname", removable: false },
  { key: "kontaktart", label: "Kontaktart", removable: true },
  { key: "verantwortlicher", label: "Verantwortlicher", removable: true },
  { key: "plz", label: "PLZ", removable: true },
  { key: "ort", label: "Ort", removable: true },
  { key: "strasse", label: "Straße", removable: true },
  { key: "telefon", label: "Telefon", removable: true },
  { key: "letzte_aktivitaet", label: "Letzte Aktivität", removable: true },
];

export const ALL_COL_KEYS = ALL_COLUMNS.map((c) => c.key);
export const LAPTOP_DEFAULT_COLS = ["firma", "kontaktart", "verantwortlicher", "telefon"];
export const LAPTOP_BREAKPOINT = 1400;

export const DEFAULT_COL_WIDTHS = {
  kundennummer: 80,
  firma: 200,
  kontaktart: 90,
  verantwortlicher: 110,
  plz: 55,
  ort: 100,
  strasse: 120,
  telefon: 110,
  letzte_aktivitaet: 240,
};

export function loadVisibleCols() {
  try {
    const raw = localStorage.getItem(VISIBLE_COLS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.includes("firma")) return parsed;
    }
  } catch { localStorage.removeItem(VISIBLE_COLS_KEY); }
  return null;
}

export function loadColWidths() {
  try {
    const raw = localStorage.getItem(COL_WIDTHS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return { ...DEFAULT_COL_WIDTHS, ...parsed };
      }
    }
  } catch { localStorage.removeItem(COL_WIDTHS_KEY); }
  return { ...DEFAULT_COL_WIDTHS };
}

// ─── Kontaktart options ───
export const KONTAKTART_OPTIONS = ["Interessent", "Kunde", "Lieferant", "Partner", "Sonstiges"];
export const KONTAKTART_COLORS = {
  Interessent: "text-orange-600 bg-orange-50 border-orange-200",
  Kunde: "text-green-700 bg-green-50 border-green-200",
  Lieferant: "text-blue-600 bg-blue-50 border-blue-200",
  Partner: "text-purple-600 bg-purple-50 border-purple-200",
  Sonstiges: "text-gray-500 bg-gray-100 border-gray-200",
};

// ─── Detail column definitions ───
import { User, Users, ClipboardList, MessageSquare, Mail, History } from "lucide-react";

export const DETAIL_COLS_DEF = [
  { id: "stammdaten", title: "Stammdaten", icon: User },
  { id: "ansprechpartner", title: "Ansprechpartner", icon: Users },
  { id: "aufgaben", title: "Aufgaben", icon: ClipboardList },
  { id: "notizen", title: "Notizen", icon: MessageSquare },
  { id: "emails", title: "Emails", icon: Mail },
  { id: "historie", title: "Historie", icon: History },
];
export const DEFAULT_DETAIL_ORDER = DETAIL_COLS_DEF.map((c) => c.id);
export const LAPTOP_AUTO_MINIMIZE = ["emails", "historie"];
